import { initializeApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword,onAuthStateChanged, signOut } from "firebase/auth";
import { getFirestore,collection,query,where,getDocs,onSnapshot,addDoc } from 'firebase/firestore';



const firebaseConfig = {
    apiKey: "AIzaSyBsVCUfjbO2jDDnBp7u6n8842m0kTn07RY",
    authDomain: "netflix-clone-ede02.firebaseapp.com",
    projectId: "netflix-clone-ede02",
    storageBucket: "netflix-clone-ede02.appspot.com",
    messagingSenderId: "677770825520",
    appId: "1:677770825520:web:a2a50977999ddca69b42f5"
  };


  const firebaseApp = initializeApp(firebaseConfig)
  const db = getFirestore()
  const auth = getAuth()

  export {auth, createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signOut}
  export {collection,query,where,getDocs,onSnapshot,addDoc}
  export default db;